import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import ArticulosOfertaModalTable from './ArticulosOfertaModalTable.js';

const ArticulosModal = (props) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const ArticulosOfertaChanged = (id, value) => {
       let articulos = props.data.articulos.filter(item=>item.id!=id);
       if(value != undefined && value != null && value != ""){
            articulos.push({id:id, value:value});
       }
       props.onChangeField("articulos", articulos);
  };
  return (
    <div>
      <Button color="info" className="w-100" onClick={toggle}>Ver Artículos</Button>
      <Modal isOpen={modal} toggle={toggle} className="modal-xl">
      <ModalHeader toggle={toggle}>Artículos</ModalHeader>
        <ModalBody>
        <ArticulosOfertaModalTable
        id_item={props.data.id_item}
        action={props.data.action}
        disabled={props.vars.disabled}
        ArticulosOfertaChanged={ArticulosOfertaChanged}
        articulos={props.data.articulos}
        />
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggle}>Cerrar</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default ArticulosModal;



// WEBPACK FOOTER //
// ./src/views/Gestion/Ventas/Ofertas/ModalOfertas/ArticulosModal.js